import { SecretRef } from "./types";

export const SECRETS_ERROR_IDENTIFIER = (secret: SecretRef) => `vault/${secret.vault}/secret/${secret.name}`

export const WARNING_FINDER = (warnings: AppError[], mapper: (arg: any) => string, item: any) => {
    const result = warnings.filter(warning => warning.source === mapper(item));
    return result
}

export const AppErrors = {
    Unknown: "There was an unknown error.",
    AzureResourceNotFound: "The resource does not exist or missing permissions to read it.",
    ForbiddenByFirewall: "Unable to interact with the resource due to firewall protections.",
    KeyvaultNotFound: "Keyvault does not exist.",
    KeyvaultReadForbidden: "Unable to read keyvault metadata.",
    SecretWriteForbidden: "Keyvault not supported.",
    SecretSoftDeleted: "Unable to modify secret when it is on soft-deletion.",
    RestrictedToUsers: "This action is limited to users.",
    RestrictedToMachines: "This action is limited to machines.",
    ForbiddenSelfApprove: "Users are forbidden to approve their own change requests.",
    MissingWritePermissions: "Write permissions on all target secrets is required for this action.",
    ForbiddenByState: "This action is forbidden in the current change request state.",
    MissingRole: "Missing required roles to perform this action.",
    UnauthorizedUnknown: "Unauthorized due to an unknown reason.",
    DisabledDueToWarnings: "This action cannot be performed due to warnings.",
    UniqueConstraint: "Value must be unique.",
    UniqueTicket: "Ticket has been already used. The same ticket can be used only if the existing change request linked to it is in CANCELED state.",
    TicketFormatInvalid: "Ticket must be of format AAA-123",
    DescriptionInvalid: "Description must be between 10 and 72 characters",
    VaultNameInvalid: "Vault name is not valid",
    SecretNameInvalid: "Secret name is not valid",
    SecretValueInvalid: "Value cannot be empty or exceed 25600 characters.",
    ChangeRequestIdInvalid: "Change request id is not valid.",
    ChangeRequestNotFound: "Couldn't find a change request matching given data.",
    UnexpectedState: "Cannot perform the operation due to unexpected state.",
    KeyvaultForbiddenByPolicy: "The keyvault cannot be used on secretmanager",
    SecretsRequired: "Change request cannot be created without secrets.",
    SecretsTooMany: "Change request contains too many secrets.",
    SecretRefNotFound: "Change request doesn't contain any secret with the provided values.",
    UserNotFound: "Could not find the user.",
    SecretRefInvalid: "Secret cannot be empty",
    SecretDataInvalid: "Secret content cannot be empty",
    ValueRequired: "Value cannot be empty",
    RollbackLimited: "Rollback is restricted to the last completed change request only.",
    SecretVersionMismatch: "Secret has been overwritten.",
    NoSecretToRollback: "Change request cannot be rolled back since all secrets are new and there is no previous version.",
    PromoteError: "Failed to promote the change request secrets.",
    RollbackError: "Failure during rolling back change request secrets.",
    RollbackIncompatible: "The change request doesn't have rollback capability.",
    AlreadyRolledBack: "The change request was already rolled back.",
    ConcurrentModification: "This change request was updated by another process. Please refresh and try again."
} as const;

export type AppErrorCode = keyof typeof AppErrors;

export type AppError = { code: AppErrorCode, message: string, source?: string }
export const AppError = (code: AppErrorCode, source?: string): AppError => ({ code, message: AppErrors[code], source });